define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var PortletModel = require('modules/portlet/portlet.model');
    var CashierIframeView = require('portlets/cashier-iframe/cashieriframe.view');
    var urlUtil = require('util/url.util');
    var serverUtil = require('util/server.util');
    var server = require('server');
    var user = require('user');
    var language = require('util/language.util');
    var cashierUtil = require('modules/cashier/cashier.util');

    module.exports = PortletModel.extend({

        defaults: {
            config: {}
        },

        parse: function(data) {
            var config = data.config;
            // backward compatibility for old portlets which had no units in settings
            config.cashierWidthUnit = config.cashierWidthUnit || 'px';
            config.cashierHeightUnit = config.cashierHeightUnit || 'px';

            return data;
        },

        getView: CashierIframeView,

        getCashierUrl: function() {
            var dfd = $.Deferred();
            var clientTypeByURL = urlUtil.getLocationParameterByName('clientType');
            var request = {
                urlTypeList: [
                    this.get('config').cashierServiceType || 'cashier'
                ]
            };

            if (clientTypeByURL) {
                request.clientType = clientTypeByURL;
            }

            serverUtil.getURLsRequest(request).done(function(response) {
                    try {
                        dfd.resolve(this.setUrlParams(response.data));
                    } catch (e) {
                        dfd.reject(e);
                    }
                }.bind(this))
                .fail(function(error) {
                    dfd.reject(error);
                });

            return dfd.promise();
        },

        initiateDocumentUpload: function(options) {
            return server.send(_.extend({
                ID: 35688,
                description: 'Initiate Document upload',
                service: 'netverify',
                responses: [35689, 35690]
            }, options));
        },

        getExtraParameters: function() {
            var portalUrlParams = urlUtil.getURLParams();
            var promoCode = cashierUtil.promoCode.getFromStorage() ||
                portalUrlParams.promocode;
            var gotoPage = this.get('config').cashierCashierPageID;
            var isNative = portalUrlParams.isNative;
            var userLang = language.getTwoLetterLanguage(user.get('lang'));

            return {
                getParams: _.extend(
                    { language: portalUrlParams.language || userLang.toUpperCase() },
                    gotoPage && { gotopage: gotoPage },
                    isNative && { isNative: isNative }
                ),

                postParams: _.extend(
                    promoCode && { promocode: promoCode }
                )
            };
        },

        setUrlParams: function(data) {
            var result = {};
            var parsedUrl;
            var getParams;
            var postParams;
            var cashierUrl;
            var fullUrl;
            var extraParams = this.getExtraParameters();

            if (data.urlList) {
                fullUrl = _.findWhere(data.urlList, {priority: 1}).url;
                parsedUrl = urlUtil.parseTemplateURL(fullUrl, {
                    origin: urlUtil.origin
                });

                cashierUrl = parsedUrl.url;
                getParams = parsedUrl.getParams;
                postParams = parsedUrl.postParams;

                _.extend(getParams, extraParams.getParams);
                _.extend(postParams, extraParams.postParams);

                result.url = cashierUrl + '?' + urlUtil.serialize(getParams);
                result.getParams = getParams;
                result.postParams = postParams;
            }

            this.set('urlParams', result);

            return result;
        }

    });
});
